/**
 * Safe getter for nested values without optional chaining
 */
function getValue(obj, path) {
  if (!obj || !path) return null;

  var keys = path.split(".");
  var result = obj;

  for (var i = 0; i < keys.length; i++) {
    if (
      result &&
      Object.prototype.hasOwnProperty.call(result, keys[i])
    ) {
      result = result[keys[i]];
    } else {
      return null;
    }
  }

  return result;
}

/**
 * Date formatter
 */
function formatDate(timestamp) {
  if (timestamp === null || timestamp === undefined) return "";

  var num = Number(timestamp);

  if (isNaN(num)) return String(timestamp);

  var date;

  // detect seconds vs milliseconds
  if (num > 946684800 && num < 1893456000) {
    date = new Date(num * 1000);
  } else {
    date = new Date(num);
  }

  if (isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  }).format(date);
}

/**
 * Format data based on column config
 */
function formatData(data, columns) {

  var formattedData = [];

  for (var i = 0; i < data.length; i++) {

    var item = data[i];
    var row = {};

    for (var j = 0; j < columns.length; j++) {

      var col = columns[j];
      var value = getValue(item, col.field);

      if (col.formatter) {
        row[col.header] = col.formatter(value, item);
      }

      else if (col.type === "date") {
        row[col.header] = formatDate(value);
      }

      else if (col.type === "boolean") {
        row[col.header] = value ? "Yes" : "No";
      }

      else if (col.type === "number") {
        row[col.header] =
          value === null || value === undefined
            ? 0
            : Number(value);
      }

      else {
        row[col.header] =
          value === null || value === undefined
            ? ""
            : value;
      }

    }

    formattedData.push(row);

  }

  return formattedData;
}

/**
 * Helper to download file
 */
function downloadFile(content, fileName, mimeType) {

  var blob = new Blob(
    [content],
    { type: mimeType }
  );

  var url = URL.createObjectURL(blob);

  var link = document.createElement("a");

  link.href = url;

  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

/**
 * CSV Export
 */
function exportCSV(data, columns, title) {

  function escapeCSV(val) {

    if (val === null || val === undefined) return "";

    var str = String(val);

    if (
      str.indexOf(",") > -1 ||
      str.indexOf('"') > -1 ||
      str.indexOf("\n") > -1
    ) {
      return '"' + str.replace(/"/g, '""') + '"';
    }

    return str;
  }

  var headers = [];

  for (var i = 0; i < columns.length; i++) {
    headers.push(
      escapeCSV(columns[i].header)
    );
  }

  var rows = [];

  for (var r = 0; r < data.length; r++) {

    var rowArr = [];

    for (var c = 0; c < columns.length; c++) {

      rowArr.push(
        escapeCSV(
          data[r][columns[c].header]
        )
      );

    }

    rows.push(rowArr.join(","));

  }

  var csv =
    headers.join(",") +
    "\n" +
    rows.join("\n");

  downloadFile(
    csv,
    title.replace(/[^a-z0-9]/gi, "_") + ".csv",
    "text/csv"
  );
}

/**
 * Excel Export (HTML table format)
 */
function exportExcel(data, columns, title) {

  var html =
    "<table border='1'><tr>";

  for (var i = 0; i < columns.length; i++) {

    html +=
      "<th>" +
      columns[i].header +
      "</th>";

  }

  html += "</tr>";

  for (var r = 0; r < data.length; r++) {

    html += "<tr>";

    for (var c = 0; c < columns.length; c++) {

      html +=
        "<td>" +
        (data[r][columns[c].header] || "") +
        "</td>";

    }

    html += "</tr>";

  }

  html += "</table>";

  downloadFile(
    html,
    title.replace(/[^a-z0-9]/gi, "_") + ".xls",
    "application/vnd.ms-excel"
  );
}

/**
 * PDF Export using browser print
 */
function exportPDF(data, columns, title, landscape) {

  var html =
    "<html>" +
    "<head>" +
    "<title>" + title + "</title>" +
    "<style>" +
    "body{font-family:Arial;padding:20px}" +
    "table{border-collapse:collapse;width:100%}" +
    "th,td{border:1px solid #ccc;padding:6px;font-size:12px}" +
    "th{background:#eee}" +
    "@page{size:" +
    (landscape ? "landscape" : "portrait") +
    "}" +
    "</style>" +
    "</head>" +
    "<body>";

  html +=
    "<h2>" + title + "</h2>";

  html += "<table><tr>";

  for (var i = 0; i < columns.length; i++) {

    html +=
      "<th>" +
      columns[i].header +
      "</th>";

  }

  html += "</tr>";

  for (var r = 0; r < data.length; r++) {

    html += "<tr>";

    for (var c = 0; c < columns.length; c++) {

      html +=
        "<td>" +
        (data[r][columns[c].header] || "") +
        "</td>";

    }

    html += "</tr>";

  }

  html +=
    "</table></body></html>";

  var win =
    window.open(
      "",
      "_blank"
    );

  win.document.open();

  win.document.write(html);

  win.document.close();

  win.focus();

  win.print();

}

/**
 * MAIN EXPORT FUNCTION
 */
export function exportFile(config) {

  var data =
    config.data || [];

  var columns =
    config.columns || [];

  var fileType =
    (config.fileType || "CSV")
      .toUpperCase();

  var title =
    config.title || "Export";

  var landscape =
    config.landscape !== false;

  var allowEmpty =
    config.allowEmpty === true;

  if (
    (!data ||
      data.length === 0) &&
    !allowEmpty
  ) {

    console.error(
      "No data found"
    );

    return;

  }

  if (
    !columns ||
    columns.length === 0
  ) {

    console.error(
      "Columns missing"
    );

    return;

  }

  var formattedData =
    formatData(
      data,
      columns
    );

  if (fileType === "CSV") {

    exportCSV(
      formattedData,
      columns,
      title
    );

  }

  if (fileType === "EXCEL") {

    exportExcel(
      formattedData,
      columns,
      title
    );

  }

  if (fileType === "PDF") {

    exportPDF(
      formattedData,
      columns,
      title,
      landscape
    );

  }

}